import { Inject, Injectable } from '@angular/core';
import { AUTOMATIONS_MARKETS_SERVICE, MarketsService } from '@galaxy/automata/shared';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class MarketOptionsDisplayService implements DataFilterDisplayService {
  constructor(
    @Inject(AUTOMATIONS_MARKETS_SERVICE) protected readonly marketsService: MarketsService,
    protected readonly translateService: TranslateService,
  ) {}
  getDisplay(value: string): Observable<string> {
    return this.marketsService.markets$.pipe(
      take(1),
      map((markets) => {
        let name = 'COMMON.UNKNOWN';
        const market = (markets || []).find((m) => m.market_id === value);
        if (market) {
          name = market.name;
        }
        return name;
      }),
      map((name) => {
        const translatedName = this.translateService.instant(name);
        return `<b>${translatedName}</b>`;
      }),
    );
  }
}
